import React, { useState } from 'react';
import { PageHeader, SchedulesForm, Show } from '../../components';
import { useCreateBreadCrumbs } from '../../hooks';
import { useTranslation } from 'react-i18next';
import { Tabs } from '@/uiComponents/common';
import CallCenterCommunication from './components/callCenterCommunication';

const ReservationsSchedule = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'screens.callCenter' });
  useCreateBreadCrumbs([{ name: t('settings'), path: '/settings' }, { name: t('title') }]);
  const [activeTab, setActiveTab] = useState('SCHEDULE');

  const tabs = [
    { isActive: activeTab === 'SCHEDULE', title: t('tabs.schedule'), type: 'SCHEDULE' },
    {
      isActive: activeTab === 'COMMUNICATION',
      title: t('tabs.communication'),
      type: 'COMMUNICATION',
    },
  ];

  const handleTabs = (type) => {
    setActiveTab(type);
  };
  return (
    <>
      <PageHeader title={t('title')} marginBottom={false} />
      {/* Formulario */}
      <Tabs options={tabs} onClick={handleTabs} />
      <Show.When isTrue={activeTab === 'SCHEDULE'}>
        <SchedulesForm sidebar callcenter />
      </Show.When>
      <Show.When isTrue={activeTab === 'COMMUNICATION'}>
        <CallCenterCommunication t={t} />
      </Show.When>
    </>
  );
};

export default ReservationsSchedule;
